export function isElectronLike(): boolean {
  try {
    const ua = String(navigator?.userAgent || '');
    // Cursor runs on Electron. Treat Electron-like shells as lower-memory environments.
    return /electron|cursor/i.test(ua);
  } catch {
    return false;
  }
}

export function isPageVisible(): boolean {
  try {
    return document?.visibilityState !== 'hidden';
  } catch {
    return true;
  }
}

export function getPollMs(baseMs: number): number {
  // Make polling MUCH less aggressive under Electron/Cursor to avoid gradual OOM.
  // 30s minimum is needed because Cursor IDE browser has limited memory headroom.
  if (!Number.isFinite(baseMs) || baseMs <= 0) return 30_000;
  if (!isElectronLike()) return baseMs;
  return Math.max(baseMs, 30_000);
}

